/**
 * marketplace.js
 * Paceline — The Marketplace public marketing page
 *
 * Responsibilities:
 *   1. Intersection Observer: fade-in sections as they enter the viewport
 *      (.mp-animate → .mp-section-in)
 *   2. Marquee: pause scroll animation on hover / resume on leave
 */

(function () {
  'use strict';

  /* ─── 1. Scroll-in animation ─────────────────────────────────────── */

  function initScrollAnimations() {
    var targets = document.querySelectorAll('.mp-animate');
    if (!targets.length) return;

    // If the browser doesn't support IntersectionObserver, just reveal all
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('mp-section-in');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mp-section-in');
            // Stop watching once revealed — no need to toggle back
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.08,       // trigger when 8% of the element is visible
        rootMargin: '0px 0px -40px 0px'  // slight offset from the bottom edge
      }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── 2. Marquee pause on hover ──────────────────────────────────── */

  function initMarqueePause() {
    var track = document.getElementById('mp-marquee-track');
    if (!track) return;

    var marquee = track.closest('.mp-marquee');
    if (!marquee) return;

    marquee.addEventListener('mouseenter', function () {
      track.classList.add('mp-marquee--paused');
    });

    marquee.addEventListener('mouseleave', function () {
      track.classList.remove('mp-marquee--paused');
    });

    // Also pause on focus (keyboard / assistive tech)
    marquee.addEventListener('focusin', function () {
      track.classList.add('mp-marquee--paused');
    });

    marquee.addEventListener('focusout', function () {
      track.classList.remove('mp-marquee--paused');
    });
  }

  /* ─── Bootstrap ─────────────────────────────────────────────────── */


  /* ─── 3. Dynamic brand marquee — paceline-mp-v3 ───────────────────────── */

  var MP_BRANDS_API = 'https://paceline-rye-production.up.railway.app/api/brands';

  function loadBrands() {
    var elA = document.getElementById('mp-mq-a');
    var elB = document.getElementById('mp-mq-b');
    if (!elA && !elB) return; // marquee not on this page

    fetch(MP_BRANDS_API)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var brands = d && d.brands;
        if (!brands || !brands.length) return;
        var seg = brands.map(function(b) { return b.name; }).join(' ✦ ');
        if (elA) elA.textContent = seg;
        if (elB) elB.textContent = seg;
      })
      .catch(function(e) { /* keep fallback text */ });
  }

  function init() {
    initScrollAnimations();
    initMarqueePause();
    loadBrands();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOMContentLoaded already fired (deferred script)
    init();
  }

})();
